// extracted by mini-css-extract-plugin
export default {"headerMenuButton":"HeaderMenu_headerMenuButton__n7Ezt","avatar":"HeaderMenu_avatar__7KclH","popupBody":"HeaderMenu_popupBody__4byZj","popupClose":"HeaderMenu_popupClose__mSZMq"};